import { render } from "./bodyController.vue?vue&type=template&id=6941bd77"
import script from "./bodyController.vue?vue&type=script&lang=js"
export * from "./bodyController.vue?vue&type=script&lang=js"

import exportComponent from "C:\\data\\jenkins_home\\workspace\\VC-AWS-PRODUCTION-FOLDER\\VC-PRODUCTION-VUE-BUILD\\code\\vue\\apps\\benefit-estimator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__